import { IGetAllObrasGestaoDeResiduosUseCase } from "../../../presentation/useCases/read/get_all_obras_gestao_de_residuos_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { GetAllObrasGestaoDeResiduosData } from "../../../data/daos/read/get_all_obras_gestao_de_residuos";

/**
 * GetAllObrasGestaoDeResiduosUseCase
 */

export class GetAllObrasGestaoDeResiduosUseCase
  extends BasePaginatedUseCase<GetAllObrasGestaoDeResiduosData>
  implements IGetAllObrasGestaoDeResiduosUseCase
{
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObrasGestaoDeResiduos(idObra?: number | null, currentPage?: number | null, rowsPerPage?: number | null): Promise<void> {
    const response = await this.repository.getObrasGestaoResiduosList({
      idObra,
      currentPage,
      rowsPerPage,
    });
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
